import { css } from "@emotion/react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Theme, useTheme } from "@mui/material";
import Link from "next/link";
import { FC } from "react";

import { mediaQueryIsMobile } from "~/lib/client/design";
import { buildAccountHref } from "~/lib/client/signupExamContext";

const CreateAccountLead: FC<{
  label: string;
  redirectPath?: string;
}> = ({ label, redirectPath }) => {
  const theme = useTheme();
  const loginHref = buildAccountHref("/account/login", {
    redirect: redirectPath,
  });
  const signupHref = buildAccountHref("/account/signup", {
    redirect: redirectPath,
  });

  return (
    <div css={rootStyle(theme)}>
      <p>{label}</p>
      <Link css={linkStyle} href={loginHref}>
        <KeyboardArrowRightIcon sx={{ marginRight: 0.25 }} />
        ログインする
      </Link>
      <Link href={signupHref} css={linkStyle}>
        <KeyboardArrowRightIcon sx={{ marginRight: 0.25 }} />
        アカウントを作成する
      </Link>
    </div>
  );
};

const rootStyle = (theme: Theme) => css`
  background: ${theme.palette.background.paper};
  width: fit-content;
  padding: 1rem;
  border: 1px solid ${theme.palette.divider};
  border-radius: 0.5rem;

  ${mediaQueryIsMobile(css`
    width: 95%;
  `)};
`;

const linkStyle = css`
  display: flex;
  align-items: center;

  &:hover {
    text-decoration: underline;
    text-underline-offset: 4px;
  }
`;

export default CreateAccountLead;
